import React from 'react';
import { useBFFStyleOptions } from '../../hooks/state/useBFFStyleOptions';
export const LoadingState = (props) => {
    const { displayText = 'preparing your experience...' } = props;
    const styleOptions = useBFFStyleOptions();
    const style = {
        '--theme-color': styleOptions.loadingColor,
        '--default-fonts': styleOptions.primaryFont
    };
    return (React.createElement("div", { className: "loader", style: style, role: "alert", "aria-live": "assertive" },
        React.createElement("span", { className: "loader-outer" },
            React.createElement("span", { className: "loader-inner" })),
        React.createElement("span", { className: "loader-label" }, displayText)));
};
//# sourceMappingURL=LoadingState.js.map